import React from 'react';
import { Heading } from '../typography/Heading';
import { Text } from '../typography/Text';

export function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Heading level={1} className="mb-8">Privacy Policy</Heading>
      
      <div className="prose max-w-none space-y-8">
        <section>
          <Heading level={2} className="mb-4">1. Information We Collect</Heading>
          <Text>
            We collect information that you provide directly to us, including:
          </Text>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Account information (name, email, password)</li>
            <li>Resume content and job descriptions</li>
            <li>Payment information (processed securely by our payment providers)</li>
            <li>Usage data and interaction with our service</li>
          </ul>
        </section>

        <section>
          <Heading level={2} className="mb-4">2. How We Use Your Information</Heading>
          <Text>
            We use the collected information for:
          </Text>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Providing and improving our services</li>
            <li>Generating cover letters</li>
            <li>Processing payments</li>
            <li>Communicating with you about our services</li>
            <li>Analyzing service usage and performance</li>
          </ul>
        </section>

        <section>
          <Heading level={2} className="mb-4">3. Information Sharing</Heading>
          <Text>
            We do not sell your personal information. We may share your information with:
          </Text>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Service providers who assist in our operations</li>
            <li>Legal authorities when required by law</li>
            <li>Third parties with your explicit consent</li>
          </ul>
        </section>

        <section>
          <Heading level={2} className="mb-4">4. Data Security</Heading>
          <Text>
            We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure. We cannot guarantee absolute security.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">5. Data Retention</Heading>
          <Text>
            We retain your information for as long as your account is active or as needed to provide services. You can request deletion of your data by contacting us.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">6. Your Rights</Heading>
          <Text>
            You have the right to:
          </Text>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to data processing</li>
            <li>Export your data</li>
          </ul>
        </section>

        <section>
          <Heading level={2} className="mb-4">7. Cookies</Heading>
          <Text>
            We use cookies and similar technologies to improve user experience and analyze service usage. You can control cookie preferences through your browser settings.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">8. Children's Privacy</Heading>
          <Text>
            Our Service is not intended for children under 13. We do not knowingly collect personal information from children under 13.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">9. Changes to Privacy Policy</Heading>
          <Text>
            We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the effective date.
          </Text>
        </section>

        <section>
          <Heading level={2} className="mb-4">10. Contact Us</Heading>
          <Text>
            If you have questions about this Privacy Policy, please contact us at:
          </Text>
          <Text className="mt-2">
            Email: <a href="mailto:info@hiiroo.com" className="text-primary hover:underline">
              info@hiiroo.com
            </a>
          </Text>
        </section>
      </div>
    </div>
  );
}